exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/view/view.component.less
// module id = 1467
// module chunks = 2